<template>
  <div>
    <l-tables
      ref="classTable"
      :content="content"
      :tableConfig="tableConfig"
      :searchParams="searchData"
      :noCreatText="noCreatText"
      :ImgSrc="nullImg"
      :emptyImgSrc="emptyImgSrc"
      @tableChange="handleTableHeaderChange"
    >
      <template slot="searchConditions">
        <div class="search-conditions">
          <a-input v-model="name" @change="search" maxlength="30" :placeholder="$t('class.inputClassName')" class="search-item">
            <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
            <img
              class="clear"
              v-if="name"
              slot="suffix"
              @click=";(name = undefined), search()"
              :src="require('@/assets/icons/icon_gb.png')"
            />
          </a-input>
        </div>
      </template>
      <template slot="searchActions">
        <a-button type="primary" @click="create">{{ $t('class.createClass') }}</a-button>
      </template>
      <template slot="create">
        <a-button type="primary" @click="create">{{ $t('class.createClass') }}</a-button>
      </template>
      <template #studentNum="{ record }">
        <a @click="view(record)">{{ record.studentNum }}{{ $t('class.studentCount') }}</a>
      </template>
      <template #type="{ record }">
        <span v-if="record.type == 1">{{ $t('class.administrativeClass') }}</span><span v-else>{{ $t('class.teachingClass') }}</span>
      </template>
      <template #classType="{ record }">
        {{ getClassTypeName(record.type) }}
      </template>
      <template #name="{ record }">
        <a-tooltip>
          <template slot="title">
            <span>{{ record.name }}</span>
          </template>
          <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{ record.name }}</div>
        </a-tooltip>
      </template>
      <template #teacherNames="{ record }">
        <a-tooltip>
          <template slot="title">
            <span v-for="(item, index) in record.teacherNames" :key="item">{{ item }}<span v-if="index !== record.teacherNames.length - 1">，</span></span>
          </template>
          <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap"><span v-for="(item, index) in record.teacherNames" :key="item">{{ item }}<span v-if="index !== record.teacherNames.length - 1">，</span></span></div>
          <div v-if="record.teacherNames.length === 0">--</div>
        </a-tooltip>
      </template>
      <template #operateCustom="{ record }">
        <div class="operate">
          <a-button type="link" @click="addStudent(record)">
            <span>{{ $t('class.addStudent') }}</span>
          </a-button>
          <a-button type="link" @click="view(record)">
            <span>{{ $t('class.view') }}</span>
          </a-button>
          <a-button type="link" @click="editClass(record)"> {{ $t('class.edit') }} </a-button>
          <a-button type="link" @click="delModal(record.id)"> {{ $t('class.delete') }} </a-button>
        </div>
      </template>
      <!-- <template #filterDropdown="props">
        <div style="padding: 8px">
          <a-radio-group 
            v-model="selectedType"
            @change="(e) => handleTypeChange(e, props)"
          >
            <a-radio-button value="1">行政班</a-radio-button>
            <a-radio-button value="2">教学班</a-radio-button>
          </a-radio-group>
        </div>
      </template> -->
    </l-tables>
    <tip-modal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="
        `
        <p>${tableConfig.tableDeleteTip && tableConfig.tableDeleteTip.title}</p>
        <p class='placeholder'>${tableConfig.tableDeleteTip && tableConfig.tableDeleteTip.content}</p>`
      "
    />

    <!-- 使用封装的班级表单弹窗组件 -->
    <class-form-modal
      :visible="modalVisible"
      :title="formTitle"
      :editData="currentEditData"
      @cancel="handleModalCancel"
      @success="handleModalSuccess"
    />

    <add-student-modal
      :visible="addStudentVisible"
      :classId="currentClass.id"
      :classType="currentClass.type"
      @cancel="handleAddStudentCancel"
      @success="handleAddStudentSuccess"
    />
  </div>
</template>

<script>
import LTables from '@/components/LTables/index.vue'
import ClassFormModal from './components/ClassFormModal.vue'
import AddStudentModal from './components/AddStudentModal.vue'
import { classDetail, classDel } from '@/api/admin'
import TipModal from '@/components/tipModal/index.vue'

export default {
  components: {
    LTables,
    ClassFormModal,
    AddStudentModal,
    TipModal
  },
  data() {
    return {
      name: undefined,
      noCreatText: '暂无数据',
      nullImg: require('@/assets/img/semesterNull.png'),
      emptyImgSrc: require('@/assets/img/bj_zanwu_2.png'),
      searchData: {
        name: ''
      },
      content: 'class',
      tableConfig: {
        tableName: '班级管理',
        tableColumns: [
          {
            title: 'ID',
            dataIndex: 'index',
            key: 'index',
            align: 'center'
          },
          {
            title: this.$t('class.classNameLabel'),
            dataIndex: 'name',
            key: 'name',
            align: 'center',
            scopedSlots: { customRender: 'name' }
          },
          {
            title: this.$t('class.teacherLabel'),
            dataIndex: 'teacherNames',
            key: 'teacherNames',
            align: 'center',
            scopedSlots: { customRender: 'teacherNames' }
          },
          {
            title: this.$t('class.studentNumLabel'),
            dataIndex: 'studentNum',
            key: 'studentNum',
            align: 'center',
            scopedSlots: { customRender: 'studentNum' }
          },
          {
            title: this.$t('class.createdAtLabel'),
            dataIndex: 'createdAt',
            key: 'createdAt',
            align: 'center'
          },
          {
            title: this.$t('class.operationLabel'),
            dataIndex: 'operate',
            key: 'operate',
            width: 300,
            align: 'center',
            scopedSlots: { customRender: 'operateCustom' }
          }
        ],
        tableDeleteTip: {
          title: this.$t('class.confirmDelete'),
          content: this.$t('class.deleteClassTip')
        },
        tablePort: {
          list: '/class/list',
          del: '/class/delete'
        },
        tableEditRouteNName: 'classAdd'
      },
      selectedType: '',
      modalVisible: false,
      formTitle: '新建班级',
      currentEditData: null,
      addStudentVisible: false,
      currentClass: {},
      delVisible: false,
      delId: undefined
    }
  },
  methods: {
    search() {
      this.searchData.name = this.name
    },
    handleTableHeaderChange([filters, getList]) {
      if (filters.type && filters.type.length > 0) {
        this.searchData.type = filters.type[0]
      } else {
        this.searchData.type = undefined
      }
      getList()
    },
    create() {
      this.formTitle = this.$t('class.createClass')
      this.currentEditData = null
      this.modalVisible = true
    },
    getClassTypeName(type) {
      const typeMap = {
        1: this.$t('class.administrativeClass'),
        2: this.$t('class.teachingClass')
      }
      return typeMap[type] || this.$t('class.unknownType')
    },
    handleTypeChange(e, props) {
      props = props.text
      const value = e.target.value

      // 更新搜索参数
      this.searchData.type = value || undefined

      // 通过 tableChange 事件触发列表刷新
      this.$refs.classTable.handlePaginationChange()

      // 如果有 confirm 方法就调用它关闭下拉框
      if (props && typeof props.confirm === 'function') {
        props.confirm()
      }
    },
    handleModalCancel() {
      this.modalVisible = false
    },
    handleModalSuccess() {
      this.modalVisible = false
      this.$refs.classTable.getList()
    },
    // 编辑班级（如果需要）
    async editClass(record) {
      this.formTitle = this.$t('class.edit')
      this.currentEditData = { ...record, classType: record.type }
      this.modalVisible = true
      const res = await classDetail({ id: record.id })
      this.currentEditData = { ...res.data }
    },
    view(record) {
      this.$router.push({
        name: 'classStudentList',
        query: { id: record.id, name: record.name, type: record.type }
      })
    },
    addStudent(record) {
      this.currentClass = record
      this.addStudentVisible = true
    },
    handleAddStudentCancel() {
      this.addStudentVisible = false
    },
    handleAddStudentSuccess() {
      this.addStudentVisible = false
      this.$refs.classTable.getList()
    },
    delModal(id) {
      this.delVisible = true
      this.delId = id
    },
    async del() {
      const res = await classDel({ id: this.delId })
      if (res.code === 200) {
        this.delVisible = false
        this.$refs.classTable.getList()
        this.$message.success(this.$t('class.deleteSuccess'))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search-conditions {
  display: flex;
  align-items: center;
  .search-item {
    margin-right: 16px;
  }
}
/deep/ .ant-radio-group {
  display: flex;
  flex-direction: column;
  .ant-radio-button-wrapper {
    margin: 4px 0;
    text-align: left;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    &:not(:first-child)::before {
      display: none;
    }
    &-checked {
      color: #1890ff;
      background: #e6f7ff;
      border-color: #1890ff;
    }
  }
}
/deep/ .operate {
  display: flex;
  justify-content: center;
  button {
    padding: 0 4px;
  }
}
</style>
